import { getSwup } from '@/lib/swup'
import { handleHashScroll, checkForHashLinks } from '@/lib/hash-scroll'
import { setupSkioListeners } from '@/lib/skio'

export function setupSwupHooks() {
	const swup = getSwup()
	if (!swup) return

	swup.hooks.on('content:replace', () => {
		const scroll = window.scrollY
		const el = document.querySelector('.is-removing-container') as HTMLElement | null
		if (el) {
			el.style.transform = `translateY(-${scroll}px)`
		}

		handleHashScroll()
		checkForHashLinks()
		setupSkioListeners()
	})
}
